import React from 'react'  
import PorovnaniDetail from './PorovnaniDetail'
import { Dropdown } from 'primereact/dropdown';

class PorovnaniZastupitelu extends React.Component {  
    constructor(props) {
        super(props);

        const searchParams = new URLSearchParams(window.location.search);
        let firstMemberValue = searchParams.get("prvni_clen") || null;
        let secondMemberValue = searchParams.get("druhy_clen") || null;

        this.members = this.props.memberOptions

        this.state = {
            firstMember: firstMemberValue !== null ? this.members.find(element => element.code === parseInt(firstMemberValue)) : null,
            secondMember: secondMemberValue !== null ? this.members.find(element => element.code === parseInt(secondMemberValue)) : null
        }

        this.onFirstMemberChange = this.onFirstMemberChange.bind(this);
        this.onSecondMemberChange = this.onSecondMemberChange.bind(this);
    }

    setParams(key, value) {
        const url = new URL(window.location);
        url.searchParams.set(key, value);
        window.history.pushState({}, '', url);
    }

    onFirstMemberChange(e) {
        let same = false;
        // prenastaveni na stejne
        if (this.state.secondMember === e.value) {
            same = true;
        }

        this.setState({ firstMember: e.value });
        if (e.value !== undefined && same === false) {
            // vse ok
            this.setParams('prvni_clen', e.value.code);
        } else {
            // zruseni filtru
            this.setState({ firstMember: null });
            const url = new URL(window.location);
            url.searchParams.delete('prvni_clen');
            window.history.pushState({}, '', url);  
        }
    }

    onSecondMemberChange(e) {
        let same = false;
        // prenastaveni na stejne
        if (this.state.firstMember === e.value) {
            same = true;
        }

        this.setState({ secondMember: e.value });
        if (e.value !== undefined && same === false) {
            // vse ok
            this.setParams('druhy_clen', e.value.code);
        } else {
            // zruseni filtru
            this.setState({ secondMember: null });
            const url = new URL(window.location);
            url.searchParams.delete('druhy_clen');
            window.history.pushState({}, '', url);  
        }
    }
        
    render() {  
        return ( 
            <div className="m-5 mt-0">
                
                <h1 className='text-primary'>Analýzy: porovnání zastupitelů</h1> 
                <div className='flex flex-column md:flex-row'>
                    <Dropdown className='md:mr-5' style={{width:"250px"}} value={this.state.firstMember} options={this.members} onChange={this.onFirstMemberChange} optionLabel="name" filter showClear filterBy="name" placeholder="Vyberte prvního člena" />
                    <Dropdown className='mt-3 md:mt-0' style={{width:"250px"}} value={this.state.secondMember} options={this.members} onChange={this.onSecondMemberChange} optionLabel="name" filter showClear filterBy="name" placeholder="Vyberte druhého člena" />
                </div>
                { (this.state.firstMember === null || this.state.secondMember === null) || ( this.state.firstMember === this.state.secondMember)
                ?
                <p>Vyberte, prosím, dva různé zastupitele.</p>
                :
                ''
                }

                <PorovnaniDetail 
                    baseUrl={ this.props.baseUrl } apiBaseUrl={this.props.apiBaseUrl} firstMember={this.state.firstMember} secondMember={this.state.secondMember}
                />
                    
            </div>
        );
    }  
}

export default PorovnaniZastupitelu